import {
  EVENT_FEED_CATALYST_COMPANY_FILTERS,
  EVENT_FEED_CATALYST_MARKET_FILTERS,
  EVENT_FEED_EARNINGS_FILTERS,
  EVENT_FEED_SCENARIO_FILTERS,
  EventFeedFilterGroupKeys,
  EventFeedType,
} from '@api';
import {
  FilterGroups,
  FilterState,
} from '@terminal/hooks/use-filter-actions/useFilterActions';
import { InsightFeedFilterTabs } from '@terminal/views/insight-feed/components/insight-feed-type-tab-line/InsightFeedTypeTabLine';

export const defaultEventFeedFilterState: FilterState = {
  activeFilterOptions: [],
  activeFilters: [],
  allFilters: [],
};

export const defaultEventFeedFilterGroups: FilterGroups<EventFeedFilterGroupKeys> =
  {
    [EVENT_FEED_SCENARIO_FILTERS]: { ...defaultEventFeedFilterState },
    [EVENT_FEED_CATALYST_COMPANY_FILTERS]: { ...defaultEventFeedFilterState },
    [EVENT_FEED_CATALYST_MARKET_FILTERS]: { ...defaultEventFeedFilterState },
    [EVENT_FEED_EARNINGS_FILTERS]: { ...defaultEventFeedFilterState },
  };

export const tabToEventFeedFilterGroup: Partial<
  Record<InsightFeedFilterTabs, EventFeedFilterGroupKeys>
> = {
  scenarios: EVENT_FEED_SCENARIO_FILTERS,
  company_catalyst: EVENT_FEED_CATALYST_COMPANY_FILTERS,
  market_catalyst: EVENT_FEED_CATALYST_MARKET_FILTERS,
  earnings: EVENT_FEED_EARNINGS_FILTERS,
};

export const tabTypeToEventFeedType: Record<
  InsightFeedFilterTabs,
  EventFeedType | undefined
> = {
  all: 'attribution-insight',
  company_catalyst: 'attribution-insight',
  market_catalyst: 'attribution-insight',
  scenarios: 'scenario-insight',
  earnings: 'earnings-insight',
  summaries: 'market-overview',
};

export const defaultEventFeedGroupNameMap: Record<
  EventFeedFilterGroupKeys,
  string
> = {
  [EVENT_FEED_SCENARIO_FILTERS]: 'Scenario',
  [EVENT_FEED_CATALYST_COMPANY_FILTERS]: 'company_catalyst',
  [EVENT_FEED_CATALYST_MARKET_FILTERS]: 'market_catalyst',
  [EVENT_FEED_EARNINGS_FILTERS]: 'Earnings',
};
